
import { CommonData } from "../../datastructures/gamestate/gameData";
import { PopUpFreeSpin } from "./freeSpinsPopInMessage";
import { FreeSpinCounter } from "./freeSpinCounter";
import { enableBet } from "../../functions/Functions_GameBar";


export class FreespinMode {

    private parent: PIXI.Container;
    private activeGameData: CommonData;
    private freeSpin: FreeSpinCounter;
    private freeSpinMessageBox: PopUpFreeSpin;
    constructor(parent: PIXI.Container, activeGameData: CommonData) {
        this.parent = new PIXI.Container();
        parent.addChild(this.parent);
        this.activeGameData = activeGameData;
        this.freeSpin = new FreeSpinCounter(this.parent);
        // this.freeSpin.updateNumber(80);
        this.freeSpin.setCount(this.activeGameData.freeSpinsCount);
        this.freeSpin.setIsMobile(this.activeGameData.isMobile);
        this.freeSpin.setPosition();


        this.freeSpinMessageBox = new PopUpFreeSpin(this.parent, this.activeGameData)

    }

    private setCount(count: number) {
        this.freeSpin.setCount(count)
    }
    // public 
    private setVisibility() {

        if (this.activeGameData.freeSpinsCount > 0) {
            this.freeSpin.setVisibile(true)// .parent.alpha = 1;
            this.activeGameData.gameBar.setFreeSpinUI(true);
        }
        else {
            this.freeSpin.setVisibile(false)//
            this.activeGameData.gameBar.setFreeSpinUI(false);

        }
    }
    // public getIsMessageBoxOpen() {
    //     return this.freeSpinMessageBox.getIsOpen();
    // }

    private setMessageWindowVisibile(bool: boolean) {
        this.freeSpinMessageBox.setVisibility(bool);
    }


//-----------


    
private useFreeSpins=(activeGameData: CommonData):void=>//no animations , Substract one free spin 
{

    //console.log("washere",activeGameData.freeSpinsCount,activeGameData.freeSpinsCount>0)
    if (activeGameData.freeSpinsCount > 0) {
        activeGameData.freeSpinsCount--;
        // activeGameData.freeSpinMode.freeSpin.updateNumberNoAnimation(activeGameData.freeSpinsCount);
        activeGameData.freeSpinMode.setCount(activeGameData.freeSpinsCount);
    }
}

private showMessageBox=(bool:boolean):void=> {
    // activeGameData.freeSpinMode.freeSpinMessageBox.displayMessage(true);
    this.activeGameData.freeSpinMode.setMessageWindowVisibile(bool)
}

private setFreeSpinBet=():void=> {
    this.activeGameData.betSelected = this.activeGameData.betList[this.activeGameData.freeSpinBetIndex]

    this.activeGameData.betIndex = this.activeGameData.freeSpinBetIndex;
    //changes the stake value to the free spin stake
    this.activeGameData.gameBar.setBetValue(this.activeGameData.betSelected.getDisplayValue());

    if (this.activeGameData.freeSpinsActive) {
        enableBet(false, this.activeGameData)
    }

    else {
        enableBet(true, this.activeGameData)
    }
}


public setMessageDisplay=():void=> {

    if (this.activeGameData.freeSpinsCount > 0 && this.activeGameData.freeSpinsActive == false) {
        this.activeGameData.freeSpinsActive = true;
        this.showMessageBox(true);
        // this.freeSpinPopup();//show in Message; 
        // this.activeGameData.freeSpinMode.setMessageWindowVisibile(true)
        this.setFreeSpinBet();
        //display freespin message box at the very start of game and update and lock bet value

    }

    else {
        if (this.activeGameData.freeSpinsCount == 0 && this.activeGameData.freeSpinsActive ){//&& winningRound==false) {

            //Display Win Window with win results total
            this.activeGameData.freeSpinsActive = false;
            // this.freeSpinPopup();//show out Message;  
            this.showMessageBox(true);   
            // this.activeGameData.freeSpinMode.setMessageWindowVisibile(true)      
            this.activeGameData.freeSpinsCount = 0;
            this.activeGameData.freeSpinMode.setCount(this.activeGameData.freeSpinsCount);// hide colored free spin text

            this.activeGameData.freeSpinsWinning = 0;
            // console.log(activeGameData.freeSpinsActive)
        }
   
    }
    // toggleFreeSpinVisibility(activeGameData);
    this.activeGameData.freeSpinMode.setVisibility()//

}



public useSpins=(activeGameData: CommonData):void=> {


    if (this.activeGameData.freeSpinsCount > 0 && this.activeGameData.bonusGameMode === false) {
        this. activeGameData.freeSpinsActive = true;
        this.useFreeSpins(activeGameData)
        //substract one each round except from the bonus game
    }
    else {
        // activeGameData.freeSpinsActive=false
    }

}
}


